<template>
  <div class="student_detaill_dialog">
    <el-dialog
      title="查看详情"
      :visible.sync="studentDetailDialog"
      width="60%"
      class="dialog_title"
    >
      <!-- /基本信息    -->
      <div class="open-header">基本信息</div>
      <el-form size="small" label-width="120px">
        <el-row>
          <el-col :span="6">
            <el-form-item label="用户名：">{{ user.username }}</el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="姓名：">{{ user.truename }}</el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="性别：">{{ user.sexy_name }}</el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="手机号：">{{ user.tel }}</el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="单位：">{{ user.unit_name }}</el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="QQ：">{{ user.qq }}</el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="邮箱：">{{ user.email }}</el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label="学段：">{{ user.level_name }}</el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="学科：">{{ user.subject_name }}</el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="职务：">{{ user.job }}</el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="职称：">{{ user.title_name }}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="详细地址：">{{ user.address }}</el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="微信：">{{ user.weixin }}</el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="学历：">{{
              user.education_name
            }}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="个人简介：">{{
              user.description
            }}</el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="教龄（年）：">{{
              user.teacher_age
            }}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="身份证号：">{{ user.idnum }}</el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="地区："
              >{{ user.province_name }}{{ user.city_name
              }}{{ user.area_name }}</el-form-item
            >
          </el-col>
          <el-col :span="24">
            <el-form-item label="备注：">{{ user.remark }}</el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <!-- 班主任的带班统计 -->
      <div v-if="type === 2">
        <div class="open-header">带班统计</div>

        <el-form size="small" label-width="120px">
          <el-row>
            <el-col :span="6">
              <el-form-item label="所带项目：">{{
                details.focus_project_count
              }}</el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="所带班级：">{{
                details.class_count
              }}</el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="学员：">{{
                details.student_count
              }}</el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="满意度："
                >{{ details.favorable }}%</el-form-item
              >
            </el-col>
          </el-row>
        </el-form>
      </div>
      <!-- 学员的 -->
      <div v-else>
        <!-- 本班级学习情况统计 -->
        <div class="open-header">本班级学习情况统计</div>
        <el-form size="small" label-width="120px">
          <el-row>
            <el-col :span="6">
              <el-form-item label="签到完成："
                >{{ statistics.sign_in_count }}/{{
                  statistics.sign_in_total
                }}</el-form-item
              >
            </el-col>
            <el-col :span="6">
              <el-form-item label="作业提交："
                >{{ statistics.work_count }}/{{
                  statistics.work_total
                }}</el-form-item
              >
            </el-col>
            <el-col :span="6">
              <el-form-item label="问卷完成："
                >{{ statistics.sign_in_count }}/{{
                  statistics.sign_in_total
                }}</el-form-item
              >
            </el-col>
            <el-col :span="6">
              <el-form-item label="资源学习："
                >{{ statistics.resources_count }}/{{
                  statistics.resources_total
                }}</el-form-item
              >
            </el-col>
            <el-col :span="6">
              <el-form-item label="组织讨论：">{{
                statistics.discuss_total
              }}</el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="参与讨论：">{{
                statistics.discuss_speak
              }}</el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="朋友圈发帖：">{{
                statistics.class_ring
              }}</el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="置顶：">{{ statistics.top }}</el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="屏蔽：">{{
                statistics.screen
              }}</el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="获赞">{{
                statistics.like_sum
              }}</el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="被评论：">{{
                statistics.comment_sum
              }}</el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="评论帖子：">{{
                statistics.comment_num
              }}</el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="屏蔽：">{{
                statistics.shield
              }}</el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="得分：">{{ statistics.score }}</el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <!-- 其他统计 -->
        <div class="open-header">其他统计</div>
        <el-form size="small" label-width="130px">
          <el-row>
            <el-col :span="6">
              <el-form-item label="入驻平台时间：">{{
                parseTime(other_statistics.enter, "{y}-{m}-{d} {h}:{i}")
              }}</el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="入驻时长："
                >{{ other_statistics.enter_time }}天</el-form-item
              >
            </el-col>
            <el-col :span="6">
              <el-form-item label="共参加纯远程项目：" label-width="140px">{{
                other_statistics.remote_project_number
              }}</el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="纯集中培训项目：" class="project">{{
                other_statistics.project_model_down
              }}</el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="混合项目：">{{
                other_statistics.class_count
              }}</el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>

      <div slot="footer" class="flex_end">
        <el-button @click="cancel" size="small">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { StudentDetail,TearcherDetail } from "@/api/tearcher";
export default {
  data() {
    return {
      studentDetailDialog: false,
      user: {},
      statistics: {},
      other_statistics: {},
      details: {},
      type: "", // 1学员，2班主任
    };
  },
  methods: {
    // 操作dialog
    operationDialog(id, type) {
      this.studentDetailDialog = true;
      this.type = type;
      //   let id = id; // 列表id
      if (type === 1) {
        StudentDetail({ id: id }).then((res) => {
          let { user, statistics, other_statistics } = res.data;
          this.user = user;
          this.statistics = statistics;
          this.other_statistics = other_statistics;
        });
      } else {
          TearcherDetail({ id: id }).then((res) => {
        let { user } = res.data;
        this.user = user;
        this.details = res.data;
      });
      }
    },
    // 取消按钮
    cancel() {
      this.studentDetailDialog = false;
    },
  },
};
</script>
 
<style lang = "less" scoped>
.student_detaill_dialog {
  .open-header {
    font-size: 18px;
    margin-bottom: 10px;
    margin-left: 15px;
    color: #303133;
  }
}
</style>